'use client';

import ReactMapGl, { Marker } from 'react-map-gl/mapbox';

import MapPin from '../../../../../../public/images/locations/map-pin.svg';
import '../../../../../styles/mapbox-gl.css';

type Props = {
    accessToken: string;
    location: any;
};

export default function LocationMap({ accessToken, location }: Props) {
    return (
        <ReactMapGl
            reuseMaps
            minZoom={4.5}
            initialViewState={{
                latitude: location.geo_point[1],
                longitude: location.geo_point[0],
                zoom: 15,
            }}
            mapStyle="mapbox://styles/mapbox/streets-v10"
            mapboxAccessToken={accessToken}
            style={{ minHeight: 1 }}>
            <Marker longitude={location.geo_point[0]} latitude={location.geo_point[1]} anchor="bottom">
                <MapPin className="text-third origin-bottom md:scale-150" />
            </Marker>
        </ReactMapGl>
    );
}
